import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class BottomModal extends Vue {
  @Prop({ default: false }) show;
  @Prop({ default: "m" }) size;
  @Prop({ default: true }) saveButton;

  destroy = true;

  @Watch("show")
  onShow() {
    if (this.show) {
      setTimeout(() => {
        document.getElementById("bottomModalOverlay").classList.add("active");
      }, 50);
      setTimeout(() => {
        this.destroy = false;
      }, 50);
      setTimeout(() => {
        document.getElementById("bottomModal").classList.add("active");
      }, 100);
    } else {
      setTimeout(() => {
        document.getElementById("bottomModal").classList.remove("active");
      }, 100);
      setTimeout(() => {
        document.getElementById("bottomModalOverlay").classList.remove("active");
      }, 50);
      setTimeout(() => {
        this.destroy = true;
      }, 50);
    }
  }

  getSize() {
    return this.size;
  }

  _closeModal() {
    this.$emit("close-modal");
  }
}
